export default __webpack_public_path__ + "static/media/jeans4.e4274408.jpeg";